// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__vjARV","innerBox":"SignUp_innerBox__7y+q0","footer":"SignUp_footer__kubhg","error":"SignUp_error__Ddf7W","cancel":"SignUp_cancel__ubQ8-"};